import { render, staticRenderFns } from "./MenuBar.vue?vue&type=template&id=08a9c6d0&scoped=true&"
import script from "./MenuBar.vue?vue&type=script&lang=ts&"
export * from "./MenuBar.vue?vue&type=script&lang=ts&"
import style0 from "./MenuBar.vue?vue&type=style&index=0&id=08a9c6d0&scoped=true&lang=scss&"
import style1 from "./MenuBar.vue?vue&type=style&index=1&lang=scss&"
import style2 from "./MenuBar.vue?vue&type=style&index=2&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08a9c6d0",
  null
  
)

export default component.exports